// Additional polyfills
import 'custom-event-polyfill'
import 'url-polyfill'

import Vue from 'vue'
import App from './App'
import router from './router'
import BootstrapVue from 'bootstrap-vue'
import VueSweetalert2 from 'vue-sweetalert2'
// If you don't need the styles, do not connect
import 'sweetalert2/dist/sweetalert2.min.css'
import globals from './globals'
import Popper from 'popper.js'
import VueGoodTablePlugin from 'vue-good-table'
import 'vue-good-table/dist/vue-good-table.css'
import { store } from './backend/vuex-storage/globalStoreParameters'
import Notifications from 'vue-notification'
import VueAwesomeSwiper from 'vue-awesome-swiper'
// import { configureFakeBackend } from './components/Auth/_helpers'
// configureFakeBackend()

// Required to enable animations on dropdowns/tooltips/popovers
Popper.Defaults.modifiers.computeStyle.gpuAcceleration = false

Vue.config.productionTip = false
Vue.use(VueGoodTablePlugin)
Vue.use(BootstrapVue)
Vue.use(VueSweetalert2)
Vue.use(Notifications)
Vue.use(VueAwesomeSwiper)
// Global RTL flag
Vue.mixin({
  data: globals
})

new Vue({
  router,
  store,
  'vue-good-table': require('vue-good-table').VueGoodTable,
  render: h => h(App)
}).$mount('#app')
